module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "adminPayments"
  }, [_c('Navigation', {
    attrs: {
      "showPromoterNav": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [(!_vm.loading && _vm.transactions.length === 0) ? _c('div', {
    staticClass: "col-md-12 p-t-6 m-t-4"
  }, [_vm._v("\n        There are no transactions yet\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 p-t-6 m-t-4"
  }, [(_vm.loaded) ? _c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.transactions), function(transaction) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(transaction.from))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transaction.to))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transaction.transaction_type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transaction.booking_code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transaction.processing_at))]), _vm._v(" "), _c('td', [(_vm.executed) ? _c('span', [_vm._v("yes")]) : _vm._e(), _vm._v(" "), (!_vm.executed) ? _c('span', [_vm._v("no")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transaction.value) + " €")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transaction.fee) + " €")])])
  }))]) : _vm._e()])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("From")]), _vm._v(" "), _c('th', [_vm._v("To")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("Booking code")]), _vm._v(" "), _c('th', [_vm._v("Processing At")]), _vm._v(" "), _c('th', [_vm._v("Processed")]), _vm._v(" "), _c('th', [_vm._v("Value")]), _vm._v(" "), _c('th', [_vm._v("Fee")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-23e10a3c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23e10a3c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/AdminPayments.vue
// module id = 766
// module chunks = 3